import React, { Component } from 'react';
import '../styles/spectrogram.css';

import Axes from './axes';
import Tuning from './tuning';
import SoundMaking from './sound-making';
import '../styles/slider-styles.css';

import { convertToLog, getFreq } from '../util/conversions';
import { Button, Icon, Progress } from 'semantic-ui-react';
// import KeyHandler, { KEYUP } from 'react-key-handler';
import { SpectrogramContext } from './spectrogram-provider';
import { loadAudioFile, toggleAudio, getBufferPosition, stopAudio } from './audio-player';

// import Logo from '../headphoneSlash.svg';
import MicPerm1 from '../Microphone Permissions 1.png';
import MicPerm2 from '../Microphone Permissions 2.png';
import MicPerm3 from '../Microphone Permissions 3.png';
import {
  WEB_CAM_WIDTH,
  WEB_CAM_HEIGHT1,
  TOUCH_START,
  TOUCH_MOVE,
  TOUCH_END,
  INFINITE_SLOPE,
  CANVAS_TOUCH_POINT_SIZE,
  MOUSE_START,
  MOUSE_MOVE,
  MOUSE_END,
  INTERPOLATION_INCREMENT_STEP,
} from '../constants';

// import WebMidi from 'webmidi';

import WebCam from './web-cam';

import { fingerJoints, fingerIdxMapping } from '../util/webCamUtilies';
import FFT from 'fft.js';

// const ReactAnimationFrame = require('react-animation-frame');

let audioContext = null;
let analyser = null;
let gainNode = null;
let audioTrack = null;
let playbackTime = 0;
let startTime = 0;
let fileInput = "";

const defaultFftSize = 2048;
// Spectrogram Graph that renders itself and 3 children canvases
// (SoundMaking/TuningMode, Axes and FrequencyRange)

class Spectrogram extends Component {
  lastTriggeredTouches = []; // this stores the previous touches triggered as per the fingertips detection in the webcam
  webCamMouseDown = false; // this is true if webcam is ON and hand is detection (similar to mousedown)
  prevTime = null;

  // Audio recording properties
  scriptProcessor = null;
  isRecording = false;
  recordingSampleRate = 44100; // sample rate of the recording

  // Incremental FFT processing during recording
  recordingBuffer = null; // Pre-allocated Float32Array for recording samples
  recordingBufferLength = 0;
  processedSampleCount = 0;
  incrementalMagnitudes = []; // Array of Float32Array(fftSize/2) per column
  incrementalProcessingTimer = null;

  // Pre-computed color lookup table (256 entries × 4 RGBA bytes)
  colorLUT = null;

  // Multi-recording support
  recordings = []; // array of recording objects: { audioBuffer, spectrogramCanvas, duration, sampleRate, totalColumns }
  combinedSpectrogramCanvas = null; // combined spectrogram of all recordings
  totalColumns = 0;

  recordedAudioContext = null;
  playbackContextStartTime = 0; // AudioContext.currentTime when playback started
  playbackAudioOffset = 0; // Offset in seconds where playback started in the audio

  constructor(props) {
    super(props);
    this.tuningRef = React.createRef();
    this.axesRef = React.createRef();
    this.lastFingerStates = {
      thumb: false,
      indexFinger: false,
      middleFinger: false,
      ringFinger: false,
      pinky: false,
    };
    this.frequencyRangeRef = React.createRef();
    this.soundMakingRef = React.createRef();
    this.fileUploadRef = React.createRef();
    this.canvasRef = React.createRef();
    this.webCamRef = React.createRef();

    this.state = {
      resolutionMax: 20000,
      resolutionMin: 20,
      musicKey: { name: 'E', value: 4 },
      accidental: { name: ' ', value: 0 },
      scale: { name: 'Blues', value: 3 },
      microphone: false,
      frequencyLabel: '',
      noteLinesRendered: false,
      midi: false,
      sustainOn: false,
      numHarmonics: 1,
      filterSustainChanged: false,
      instr: true,
      justIntonation: false,
      log: true,
      webCamEnabled: false,
      pendingTouches: [], // this stores the pending touches events which are yet to be triggered
      recording: false,
      showRecordedSpectrogram: false,
      hasRecording: false,
      recordingCount: 0,
      recordingScrollPosition: 0,
      scrollbarPlaying: false,
      // Clip selection state: { start: 0-1, end: 0-1 } or null
      clipSelection: null,
      clipPlaying: false,
      showSavePrompt: false,
      clipLabel: '',
      previousLabels: [],
      showLabelSuggestions: false,
      // deferredPrompt: null,
      // showAddToHomeScreen: false
    };
    this.animationFrameId = null;
    this.columnIntervalId = null;

    this.isSelectingClip = false;
    this.clipDragStartX = null;

    // bind method
    this.stopAnimation = this.stopAnimation.bind(this);
  }
  componentDidUpdate(prevProps, prevState, prevContext) {
    if (analyser && this.context.state.fftSize !== prevContext?.state?.fftSize) {
      analyser.fftSize = this.context.state.fftSize;
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('load', this.startSpectrogram);
    window.addEventListener('keyup', this.spacePressed);
    this.loadSavedLabels();

    this.ctx = this.canvas.getContext('2d');
    this.tempCanvas = document.createElement('canvas');
    this.initColorLUT();
    this.context.loadTsModel(); // loading tensorflow handpose model in the spectrogram context

    // Create a simple semi-transparent overlay that prompts the user to click/tap
    // to start the spectrogram. This ensures a user gesture will be captured even
    // if the window 'load' event doesn't trigger in time.
    if (!this.context.state.isStarted) {
      try {
        this.overlayElement = document.createElement('div');
        Object.assign(this.overlayElement.style, {
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0,0,0,0.45)',
          color: '#fff',
          fontSize: '1.25rem',
          zIndex: '9999',
          cursor: 'pointer',
        });
        this.overlayElement.textContent = 'Click or tap to start';
        this.overlayElement.addEventListener(
          'pointerdown',
          (ev) => {
            ev.preventDefault();
            // ensure canvas/context refs are current
            this.canvas = this.canvas || document.getElementById('spectrogramCanvas');
            try {
              this.ctx = this.canvas ? this.canvas.getContext('2d') : this.ctx;
            } catch (e) {
              // ignore
            }
            this.startSpectrogram();
            if (this.overlayElement && this.overlayElement.parentNode) {
              this.overlayElement.parentNode.removeChild(this.overlayElement);
            }
            this.overlayElement = null;
          },
          { once: true }
        );
        document.body.appendChild(this.overlayElement);
      } catch (e) {
        console.warn('[Spectrogram] could not create start overlay', e);
        this.overlayElement = null;
      }
    }
    // WebMidi.enable((err) => {
    //   if (err) {
    //     console.log('WebMidi could not be enabled.', err);
    //   }
    //   console.log('Success');
    //   this.context.handleMIDIEnabled();
    // });
    // window.addEventListener('beforeinstallprompt', (e) => {
    //   // Prevent Chrome 67 and earlier from automatically showing the prompt
    //   e.preventDefault();
    //   // Stash the event so it can be triggered later.
    //   this.setState({deferredPrompt: e, showAddToHomeScreen:true});
    // });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keyup', this.spacePressed);
    this.stopAnimation();
    // Remove overlay if still present
    if (this.overlayElement && this.overlayElement.parentNode) {
      try {
        this.overlayElement.parentNode.removeChild(this.overlayElement);
      } catch (e) {
        // ignore
      }
      this.overlayElement = null;
    }
  }

  // Lifecycle method which gets called before render
  shouldComponentUpdate(nextProps, nextState) {
    let shouldUpdate = false;
    // shouldUpdate should be false if only handleResize method is changed due to rerender of parent component
    Object.entries(nextProps).forEach(([key, val]) => {
      if (key !== 'handleResize' && this.props[key] !== val) {
        shouldUpdate = true;
      }
    });
    if (nextState) {
      Object.entries(nextState).forEach(([key, val]) => {
        if (this.state[key] !== val) {
          shouldUpdate = true;
        }
      });
    }
    return shouldUpdate;
  }

  stopAnimation = () => {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    if (this.columnIntervalId) {
      clearInterval(this.columnIntervalId);
    }
  };

  // Starts the Spectrogram and Children Components when the user taps the screen
  // Also creates the audioContext to be used throughout the application
  startSpectrogram = () => {
    if (!this.context.state.isStarted) {
      // For animation frame
      this.animationFrameId = requestAnimationFrame(this.onAnimationFrame);

      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      audioContext = new AudioCtx();

      analyser = audioContext.createAnalyser();
      gainNode = audioContext.createGain();
      analyser.minDecibels = -100;
      analyser.maxDecibels = -20;
      analyser.smoothingTimeConstant = 0;
      analyser.fftSize = this.context.state.fftSize || defaultFftSize;

      // Prompt for microphone. Has been moved down to within onAnimationFrame
      // if (navigator.mediaDevices.getUserMedia) {
      //   navigator.mediaDevices.getUserMedia({
      //       audio: true
      //     })
      //     .then(this.onStream.bind(this))
      //     .catch(this.onStreamError.bind(this));
      // }
      // else if (navigator.mozGetUserMedia) {
      //   navigator.mozGetUserMedia({
      //     audio: true
      //   }, this.onStream.bind(this), this.onStreamError.bind(this));
      // } else if (navigator.webkitGetUserMedia) {
      //   navigator.webkitGetUserMedia({
      //     audio: true
      //   }, this.onStream.bind(this), this.onStreamError.bind(this));
      // }

      // Calls the start function which lets the controls know it has started
      this.context.start();
      // Remove overlay if it still exists (safety cleanup)
      if (this.overlayElement && this.overlayElement.parentNode) {
        try {
          this.overlayElement.parentNode.removeChild(this.overlayElement);
        } catch (e) {
          // ignore
        }
        this.overlayElement = null;
      }
      this.renderFreqDomain();

      // Start timer-based column drawing with fixed interval
      this.columnIntervalId = setInterval(() => {
        if (analyser) {
          this.renderFreqDomain();
        }
      }, this.context.state.columnDrawInterval);
      /*{this.setState({ instr: false });
        setTimeout(this.handleInstructionsClose, 5000);}*/
    } //else {
    //   this.context.menuClose();
    // }
  };

  requestMicrophoneAccess = () => {
    if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({
          audio: true,
        })
        .then(this.onStream.bind(this))
        .catch(this.onStreamError.bind(this));
    } else if (navigator.mozGetUserMedia) {
      navigator.mozGetUserMedia(
        {
          audio: true,
        },
        this.onStream.bind(this),
        this.onStreamError.bind(this)
      );
    } else if (navigator.webkitGetUserMedia) {
      navigator.webkitGetUserMedia(
        {
          audio: true,
        },
        this.onStream.bind(this),
        this.onStreamError.bind(this)
      );
    }
  };

  // Sets up the microphone stream after the Spectrogram is started
  // It connects the graph by connecting the microphone to gain and gain to
  // the analyser. The gain is used as microphoneGain
  onStream(stream) {
    audioTrack = stream.getTracks()[0];
    let input = audioContext.createMediaStreamSource(stream);
    input.connect(gainNode);
    gainNode.connect(analyser);
    gainNode.gain.setTargetAtTime(1, audioContext.currentTime, 0.01);
    this.context.handleMicPermissionToggle(true);
  }

  onStreamError(e) {
    console.error(e);
    console.log('Microphone has not been enabled. Please enable the microphone.');
    this.context.handleMicPermissionToggle(false);
    this.handleModalToggle();
  }

  // This method plays sound for the given mouse event depending on its type
  playMouseEventSound = (mouseEvent) => {
    const mouseEventType = mouseEvent.type;
    if (this.context.state.tuningMode) {
      switch (mouseEventType) {
        case MOUSE_START:
          this.tuningRef.current.onMouseDown(mouseEvent);
          break;
        case MOUSE_MOVE:
          this.tuningRef.current.onMouseMove(mouseEvent);
          break;
        case MOUSE_END:
          this.tuningRef.current.onMouseUp(mouseEvent);
          break;
        default:
      }
    } else {
      switch (mouseEventType) {
        case MOUSE_START:
          this.soundMakingRef.current.onMouseDown(mouseEvent);
          break;
        case MOUSE_MOVE:
          this.soundMakingRef.current.onMouseMove(mouseEvent);
          break;
        case MOUSE_END:
          this.soundMakingRef.current.onMouseUp(mouseEvent);
          break;
        default:
      }
    }
  };

  // This method plays sound for the given touch event depending on its type
  playTouchEventSound = (touchEvent) => {
    const touchEventType = touchEvent.type;
    if (this.context.state.tuningMode) {
      switch (touchEventType) {
        case TOUCH_START:
          this.tuningRef.current.onTouchStart(touchEvent);
          break;
        case TOUCH_MOVE:
          this.tuningRef.current.onTouchMove(touchEvent);
          break;
        case TOUCH_END:
          this.tuningRef.current.onTouchEnd(touchEvent);
          break;
        default:
      }
    } else {
      switch (touchEventType) {
        case TOUCH_START:
          this.soundMakingRef.current.onTouchStart(touchEvent);
          break;
        case TOUCH_MOVE:
          this.soundMakingRef.current.onTouchMove(touchEvent);
          break;
        case TOUCH_END:
          this.soundMakingRef.current.onTouchEnd(touchEvent);
          break;
        default:
      }
    }
  }

  // Continuous render of the graph (if started) using ReactAnimationFrame plugin
  onAnimationFrame = (time) => {
    this.animationFrameId = requestAnimationFrame(this.onAnimationFrame);

    // Update scroll position during recorded audio playback
    if (this.state.scrollbarPlaying && this.recordings.length > 0) {
      const currentPosition = this.getCurrentPlaybackPosition();

      if (currentPosition >= 1) {
        this.setState({ scrollbarPlaying: false, recordingScrollPosition: 1 });
      } else {
        this.setState({ recordingScrollPosition: currentPosition });
      }
    }

    if (this.state.showRecordedSpectrogram && this.combinedSpectrogramCanvas) {
      this.renderRecordedSpectrogram();
      return;
    }

    if (this.context.state.isStarted) {
      // Resume audioContext if suspended for whatever reason
      if (audioContext && audioContext.state !== 'closed' && audioContext.state !== 'running') {
        audioContext.resume().then(() => {
          console.log('Playback resumed successfully');
        });
      }
      if (this.tuningRef.current) {
        if (this.context.state.noteLinesOn && !this.state.noteLinesRendered) {
          this.tuningRef.current.removeNoteLines();
          this.tuningRef.current.renderNoteLines();
          this.setState({ noteLinesRendered: true });
        }
        if (!this.context.state.noteLinesOn && this.state.noteLinesRendered) {
          this.tuningRef.current.removeNoteLines();
          this.setState({ noteLinesRendered: false });
        }
      }
      if (this.soundMakingRef.current) {
        if (this.context.state.noteLinesOn && !this.state.noteLinesRendered) {
          this.soundMakingRef.current.renderNoteLines();
          // this.soundMakingRef.current.drawPitchBendButton(false);
          this.setState({ noteLinesRendered: true });
        } else if (!this.context.state.noteLinesOn && this.state.noteLinesRendered) {
          this.soundMakingRef.current.removeNoteLines();
          // this.soundMakingRef.current.drawPitchBendButton(false);
        }

        if (!this.context.state.noteLinesOn) {
          this.setState({ noteLinesRendered: false });
        }
        if (
          (this.context.state.soundOn &&
            this.context.state.sustain &&
            this.context.state.numHarmonics !== this.state.numHarmonics) ||
          this.context.state.filterSustainChanged !== this.state.filterSustainChanged
        ) {
          this.soundMakingRef.current.sustainChangeTimbre();
          this.setState({
            numHarmonics: this.context.state.numHarmonics,
            filterSustainChanged: this.context.state.filterSustainChanged,
          });
        }
        if (this.context.state.soundOn && this.context.state.sustain && !this.state.sustainOn) {
          this.setState({ sustainOn: true });
        } else if (!this.context.state.sustain && this.state.sustainOn) {
          this.soundMakingRef.current.releaseAll();
          this.setState({ sustainOn: false });
        } else if (
          this.context.state.sustain &&
          !this.context.state.soundOn &&
          this.state.sustainOn
        ) {
          this.soundMakingRef.current.releaseAll();
        }
      }

      if (
        this.context.state.resolutionMax !== this.state.resolutionMax ||
        this.context.state.resolutionMin !== this.state.resolutionMin ||
        this.context.state.log !== this.state.log
      ) {
        // Rerender if components exist
        if (this.axesRef.current) {
          this.axesRef.current.renderAxesLabels();
        }
        if (this.tuningRef.current && this.context.state.noteLinesOn) {
          this.tuningRef.current.removeNoteLines();
          this.tuningRef.current.renderNoteLines();
        }
        if (this.soundMakingRef.current && this.context.state.noteLinesOn) {
          this.soundMakingRef.current.removeNoteLines();
          this.soundMakingRef.current.renderNoteLines();
          // this.soundMakingRef.current.drawPitchBendButton(false);
        }

        this.setState({
          resolutionMax: this.context.state.resolutionMax,
          resolutionMin: this.context.state.resolutionMin,
          log: this.context.state.log,
        });
      }
      if (
        this.context.state.scale !== this.state.scale ||
        this.context.state.musicKey !== this.state.musicKey ||
        this.context.state.accidental !== this.state.accidental ||
        this.context.state.justIntonation !== this.state.justIntonation
      ) {
        if (this.tuningRef.current && this.context.state.noteLinesOn) {
          this.tuningRef.current.removeNoteLines();
          this.tuningRef.current.renderNoteLines();
        }
        if (this.frequencyRangeRef.current && !this.context.state.noteLines) {
          // this.frequencyRangeRef.current.renderNoteLines();
        }
        if (this.soundMakingRef.current && this.context.state.noteLinesOn) {
          this.soundMakingRef.current.removeNoteLines();
          this.soundMakingRef.current.renderNoteLines();
          // this.soundMakingRef.current.drawPitchBendButton(false);
        }
        this.setState({
          scale: this.context.state.scale,
          musicKey: this.context.state.musicKey,
          accidental: this.context.state.accidental,
          justIntonation: this.context.state.justIntonation,
        });
      }

      let gain = convertToLog(this.context.state.microphoneGain, 1, 100, 0.01, 500);
      if (gain !== gainNode.gain.value) {
        gainNode.gain.setTargetAtTime(gain, audioContext.currentTime, 0.01);
      }
      // Turn on/off the microphone by calling audioTrack.stop() and then restarting the stream
      // This checks the readyState of the audioTrack for status of the microphone

      // First section is for microphone has not been set up yet
      if (!audioTrack && this.context.state.startMicrophone && !this.state.microphone) {
        console.log('try setting up the mic...');

        // ask for permission and set up mic
        this.requestMicrophoneAccess();

        this.setState({ microphone: true });
      } else if (audioTrack && this.context.state.startMicrophone) {
        if (!this.context.state.microphone && audioTrack.readyState === 'live') {
          audioTrack.stop();
          this.setState({ microphone: !this.state.microphone });
        } else if (
          audioTrack &&
          this.context.state.microphone &&
          audioTrack.readyState === 'ended' &&
          !this.state.microphone
        ) {
          if (navigator.mozGetUserMedia) {
            navigator.mozGetUserMedia(
              {
                audio: true,
              },
              this.onStream.bind(this),
              this.onStreamError.bind(this)
            );
          } else if (navigator.webkitGetUserMedia) {
            navigator.webkitGetUserMedia(
              {
                audio: true,
              },
              this.onStream.bind(this),
              this.onStreamError.bind(this)
            );
          }

          this.setState({ microphone: !this.state.microphone });
        }
      }

      // if (this.context.state.midi && !this.state.midi) {
      //   try {
      //     let input = WebMidi.inputs[0];
      //     input.addListener('noteon', 'all', this.soundMakingRef.current.MIDINoteOn);
      //     input.addListener('noteoff', 'all', this.soundMakingRef.current.MIDINoteOff);
      //     this.setState({ midi: true });
      //   } catch (e) {
      //     console.error('No MIDI Device 1');
      //     this.context.handleMIDIChange();
      //   }
      //   // finally {
      //   // }
      // } else if (!this.context.state.midi && this.state.midi) {
      //   try {
      //     let input = WebMidi.inputs[0];
      //     input.removeListener('noteon', 'all', this.soundMakingRef.current.MIDINoteOn);
      //     input.removeListener('noteoff', 'all', this.soundMakingRef.current.MIDINoteOff);
      //     // this.setState({midi: false});
      //   } catch (e) {
      //     console.error('NO MIDI Device 2');
      //   } finally {
      //     this.setState({ midi: false });
      //   }
      // }
      if (this.context.state.audioFilePlayback) {
        if (startTime === 0) {
          startTime = time;
        }
        playbackTime = time - startTime;
        let progress = getBufferPosition(playbackTime / 1000) * 100;
        if (progress === 100) {
          startTime = 0;
          this.toggleAudio();
        }
        this.context.setAudioFileProgress(progress);
      } else {
        startTime = 0;
      }
    }
  };

  toggleAudio = () => {
    toggleAudio();
    if (this.context.audioFilePlayback) {
      startTime = 0;
    }
    this.context.handleAudioFileToggle();
  };

  handleFileUpload = (e) => {
    const fileUploaded = e.target.files[0];
    if (fileUploaded) {
      this.context.handleFileUpload();
      loadAudioFile(fileUploaded, audioContext, analyser);
      startTime = 0;
      fileInput = '';
    }
  };

  stopAudio = () => {
    stopAudio();
    startTime = 0;
    this.context.handleAudioFileRemoved();
  };

  // Calculates the square of manhattan distance between two points
  manhattanDistance = (x1, y1, x2, y2) => {
    return (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
  };

  // Detects the fingers which are opened by taking the landmarks object containing
  // the locations (x, y, z) of each finger of the palm
  detectOpenedFingers = (landmarks) => {
    let openedFingers = [];
    // Coordinate of the lowest point of the palm
    const lowestX = landmarks[0].x;
    const lowestY = landmarks[0].y;
    for (let j = 0; j < Object.keys(fingerJoints).length; j++) {
      let finger = Object.keys(fingerJoints)[j];
      if (finger === "thumb") {
        continue;
      }
      let isFingerOpened = true;
      for (let k = 1; k < fingerJoints[finger].length; k++) {
        // Get pairs of consecutive joints
        const prevJointIndex = fingerJoints[finger][k - 1];
        const jointIndex = fingerJoints[finger][k];
        // The finger is opened only if next keypoint coordinate manhattan distance is
        // more than the previous keypoint coordinate manhattan distance from the lowest point
        // of the palm for all the detected keypoints of the finger
        if (
          this.manhattanDistance(
            lowestX,
            lowestY,
            landmarks[prevJointIndex].x,
            landmarks[prevJointIndex].y
          ) >
          this.manhattanDistance(
            lowestX,
            lowestY,
            landmarks[jointIndex].x,
            landmarks[jointIndex].y
          )
        ) {
          isFingerOpened = false;
          break;
        }
      }
      if (isFingerOpened) {
        openedFingers.push(finger);
      }
    }
    return openedFingers;
  };

  // Add a smoothing function
  smoothLandmarks = (currentLandmarks, previousLandmarks, smoothingFactor = 0.8) => {
    if (!previousLandmarks) return currentLandmarks;
    return currentLandmarks.map((landmark, index) => ({
      x: smoothingFactor * previousLandmarks[index].x + (1 - smoothingFactor) * landmark.x,
      y: smoothingFactor * previousLandmarks[index].y + (1 - smoothingFactor) * landmark.y,
    }));
  };

  // Method to determine the center of the palm and play sound
  // by triggering touch corresponding to location of center of the palm
  triggerTouchEvents = (predictions) => {
    if (predictions.length > 0) {
      let prediction = predictions[0];
      // Grab landmarks
      const landmarks = prediction.keypoints;

      // Smooth the landmarks
      const smoothedLandmarks = this.smoothLandmarks(landmarks, this.previousLandmarks);
      this.previousLandmarks = smoothedLandmarks;

      // Use smoothedLandmarks instead of landmarks
      let x = (smoothedLandmarks[0].x + smoothedLandmarks[9].x) / 2;
      let y = (smoothedLandmarks[0].y + smoothedLandmarks[9].y) / 2;
      this.webCamRef.current.drawFingerJoint(x, y);

      // Scale x and y
      // Subtract from this.canvas.width since the location coordinates obtained is as per lateral inversion
      x = this.canvas.width - (x / WEB_CAM_WIDTH) * this.canvas.width;
      y = Math.min(this.canvas.height, (y / WEB_CAM_HEIGHT1) * this.canvas.height);
      const touchId = 0;
      let touches = [];
      touches.push(new Touch({ identifier: touchId, clientX: x, clientY: y, target: window }));
      // Reason: no getter
      let touchCopy = new Touch({ identifier: touchId, clientX: x, clientY: y, target: window });
      this.ctx.beginPath();
      this.ctx.arc(x, y, CANVAS_TOUCH_POINT_SIZE, 0, 3 * Math.PI);
      this.ctx.fillStyle = 'yellow';
      this.ctx.fill();
      let lastTouches = [...this.lastTriggeredTouches];
      let touchEvent = null;
      if (!lastTouches || lastTouches.length === 0) {
        // This is the first time touch is triggered since lastTouches is empty
        // Hence trigger touchstart event
        touchEvent = new TouchEvent(TOUCH_START, {
          touches: touches,
          view: window,
          cancelable: true,
          changedTouches: touches,
        });
        this.playTouchEventSound(touchEvent);
        lastTouches.push(touchCopy);
      } else {
        if (lastTouches && lastTouches.length > 0) {
          if (lastTouches.length > 0) {
            lastTouches.shift();
            // lastTouches is not empty, hence trigger touchmove event
            let touchEvent = new TouchEvent(TOUCH_MOVE, {
              touches: touches,
              view: window,
              cancelable: true,
              changedTouches: touches,
            });
            this.playTouchEventSound(touchEvent);
            lastTouches.push(touchCopy);
          }
        }
      }
      this.lastTriggeredTouches = lastTouches;
    } else {
      // No hand was detected, thus touchend event needs to be triggered
      let lastTouches = this.lastTriggeredTouches;
      if (lastTouches && lastTouches.length > 0) {
        let lastTouch = lastTouches.shift();
        let changedTouches = [];
        changedTouches.push(lastTouch);
        let touchEvent = new TouchEvent(TOUCH_END, {
          touches: [],
          view: window,
          cancelable: true,
          changedTouches: changedTouches,
        });
        this.playTouchEventSound(touchEvent);
        this.lastTriggeredTouches = lastTouches;
      }
      // Reset previousLandmarks if no hand is detected
      this.previousLandmarks = null;
    }
  };

  // Method which triggers multiple touch events given the predictions
  // containing the detected keypoints of each finger of the palm
  triggerMultiTouchEvents = (predictions) => {
    if (predictions.length > 0) {
      let prediction = predictions[0];
      // Grab landmarks
      const landmarks = prediction.landmarks;
      let thumbTouchLocationX = landmarks[4][0];
      let thumbTouchLocationY = landmarks[4][1];
      let indexTouchLocationX = landmarks[8][0];
      let indexTouchLocationY = landmarks[8][1];
      let middleTouchLocationX = landmarks[12][0];
      let middleTouchLocationY = landmarks[12][1];
      let ringTouchLocationX = landmarks[16][0];
      let ringTouchLocationY = landmarks[16][1];
      let pinkyTouchLocationX = landmarks[20][0];
      let pinkyTouchLocationY = landmarks[20][1];
      let fingerTouchLocations = [
        thumbTouchLocationX,
        thumbTouchLocationY,
        indexTouchLocationX,
        indexTouchLocationY,
        middleTouchLocationX,
        middleTouchLocationY,
        ringTouchLocationX,
        ringTouchLocationY,
        pinkyTouchLocationX,
        pinkyTouchLocationY,
      ];
      // Scale x and y
      const touchId = 0;
      let touches = [];
      let touchesCopy = [];
      for (let i = 0; i < fingerTouchLocations.length; i += 2) {
        let x = fingerTouchLocations[i];
        let y = fingerTouchLocations[i + 1];
        this.webCamRef.current.drawFingerJoint(x, y);
        // Scale x and y 
        x = this.canvas.width - (x / WEB_CAM_WIDTH) * this.canvas.width;
        y = Math.min(this.canvas.height, (y / WEB_CAM_HEIGHT1) * this.canvas.height);
        touches.push(new Touch({ identifier: touchId, clientX: x, clientY: y, target: window }));
        // Reason: no getter
        let touchCopy = new Touch({ identifier: touchId, clientX: x, clientY: y, target: window });
        touchesCopy.push(touchCopy);
        this.ctx.beginPath();
        this.ctx.arc(x, y, CANVAS_TOUCH_POINT_SIZE, 0, 3 * Math.PI);
        this.ctx.fillStyle = 'yellow';
        this.ctx.fill();
      }
      let lastTouches = [...this.lastTriggeredTouches];
      let touchEvent = null;
      if (!lastTouches || lastTouches.length === 0) {
        // This is the first time touch occurs, hence trigger touchstart event
        touchEvent = new TouchEvent(TOUCH_START, {
          touches: touches,
          view: window,
          cancelable: true,
          changedTouches: touches,
        });
        this.playTouchEventSound(touchEvent);
        lastTouches = lastTouches.concat(touchesCopy);
      } else {
        if (
          lastTouches &&
          lastTouches.length > 0 &&
          (lastTouches[0].clientX !== touchesCopy[0].clientX ||
            lastTouches[0].clientY !== touchesCopy[0].clientY)
        ) {
          while (lastTouches.length > 0) {
            lastTouches.shift();
          }
          // lastTouches is not empty, hence trigger touchmove event
          const touchEvent = new TouchEvent(TOUCH_MOVE, {
            touches: touches,
            view: window,
            cancelable: true,
            changedTouches: touches,
          });
          this.playTouchEventSound(touchEvent);
          lastTouches = lastTouches.concat(touchesCopy);
        }
      }
      this.lastTriggeredTouches = lastTouches;
    } else {
      // No hand was detected, thus touchend event needs to be triggered
      let lastTouches = this.lastTriggeredTouches;
      if (lastTouches && lastTouches.length > 0) {
        let changedTouches = [];
        while (lastTouches.length > 0) {
          let lastTouch = lastTouches.shift();
          changedTouches.push(lastTouch);
        }
        const touchEvent = new TouchEvent(TOUCH_END, {
          touches: [],
          view: window,
          cancelable: true,
          changedTouches: changedTouches,
        });
        this.playTouchEventSound(touchEvent);
        this.lastTriggeredTouches = lastTouches;
      }
    }
  };

  // Method which triggers multiple touch events corresponding to only opened
  // fingers of the palm given the predictions
  // containing the detected keypoints of each finger of the palm
  triggerMultiTouchEventsWithOnlyOpenedFingers = (predictions) => {
    if (predictions.length > 0) {
      let prediction = predictions[0];
      const landmarks = prediction.keypoints;
      const openedFingers = this.detectOpenedFingers(landmarks);

      // Create a map for current finger states
      const currentFingerStates = {
        indexFinger: false,
        middleFinger: false,
        ringFinger: false,
        pinky: false,
      };

      // Update current finger states based on opened fingers
      openedFingers.forEach((finger) => {
        currentFingerStates[finger] = true;
      });

      // Arrays to hold touch events
      let touchStartList = [];
      let touchMoveList = [];
      let touchEndList = [];

      // Loop through each finger to detect state changes
      Object.keys(fingerJoints).forEach((finger, idx) => {
        const wasFingerOpen = this.lastFingerStates[finger];
        const isFingerOpen = currentFingerStates[finger];

        if (isFingerOpen) {
          const jointIndex = fingerJoints[finger][fingerJoints[finger].length - 1];
          const landmark = landmarks[jointIndex];

          // Draw on the canvas
          this.webCamRef.current.drawFingerJoint(landmark.x, landmark.y);

          // Scale coordinates
          let x = this.canvas.width - (landmark.x / WEB_CAM_WIDTH) * this.canvas.width;
          let y = Math.min(this.canvas.height, (landmark.y / WEB_CAM_HEIGHT1) * this.canvas.height);

          const touch = new Touch({ identifier: idx, clientX: x, clientY: y, target: window });

          if (wasFingerOpen) {
            // Finger remains open, trigger touchmove
            touchMoveList.push(touch);
          } else {
            // Finger was closed, now open, trigger touchstart
            touchStartList.push(touch);
          }
        } else {
          if (wasFingerOpen) {
            // Finger was open, now closed, trigger touchend
            const lastTouch = this.lastTriggeredTouches[idx];
            if (lastTouch) {
              touchEndList.push(lastTouch);
            }
          }
        }
      });

      // Trigger touchstart events
      if (touchStartList.length > 0) {
        const touchEvent = new TouchEvent('touchstart', {
          touches: touchStartList,
          view: window,
          cancelable: true,
          changedTouches: touchStartList,
        });
        this.playTouchEventSound(touchEvent);
      }

      // Trigger touchmove events
      if (touchMoveList.length > 0) {
        const touchEvent = new TouchEvent('touchmove', {
          touches: touchMoveList,
          view: window,
          cancelable: true,
          changedTouches: touchMoveList,
        });
        this.playTouchEventSound(touchEvent);
      }

      // Trigger touchend events
      if (touchEndList.length > 0) {
        const touchEvent = new TouchEvent('touchend', {
          touches: [],
          view: window,
          cancelable: true,
          changedTouches: touchEndList,
        });
        this.playTouchEventSound(touchEvent);
      }

      // Update lastFingerStates and lastTriggeredTouches
      this.lastFingerStates = currentFingerStates;
      this.lastTriggeredTouches = [];
      Object.keys(fingerJoints).forEach((finger, idx) => {
        if (currentFingerStates[finger]) {
          const touch = touchStartList.find((t) => t.identifier === idx) ||
            touchMoveList.find((t) => t.identifier === idx);
          this.lastTriggeredTouches[idx] = touch;
        } else {
          this.lastTriggeredTouches[idx] = null;
        }
      });
    } else {
      // No hand detected, trigger touchend for all open fingers
      let touchEndList = [];
      Object.keys(fingerJoints).forEach((finger, idx) => {
        if (this.lastFingerStates[finger]) {
          const lastTouch = this.lastTriggeredTouches[idx];
          if (lastTouch) {
            touchEndList.push(lastTouch);
          }
        }
      });

      if (touchEndList.length > 0) {
        const touchEvent = new TouchEvent('touchend', {
          touches: [],
          view: window,
          cancelable: true,
          changedTouches: touchEndList,
        });
        this.playTouchEventSound(touchEvent);
      }

      // Reset states
      this.lastFingerStates = {
        thumb: false,
        indexFinger: false,
        middleFinger: false,
        ringFinger: false,
        pinky: false,
      };
      this.lastTriggeredTouches = [];
    }
  };

  // Method which returns true if all the elements inside the array are null
  isArrayContentsNull = (array) => {
    if (array.length === 0) return true;
    for (let i = 0; i < array.length; i++) {
      if (array[i] !== null) {
        return false;
      }
    }
    return true;
  };

  // Method which returns non null elements from the array
  removeNullFromArray = (array) => {
    var notNullArray = [];
    for (let i = 0; i < array.length; i++) {
      if (array[i] !== null) {
        notNullArray.push(array[i]);
      }
    }
    return notNullArray;
  };

  // Caculates slope of the two points
  calculateSlope = (prevX, prevY, curX, curY) => {
    if (curX === prevX) return INFINITE_SLOPE;
    return (curY - prevY) / (curX - prevX);
  };

  // Interpolate the touches between prevTouches and curTouches where 'nOpenedFingers'
  // indicates number of opened fingers in the detected palm
  getInterpolatedTouches = (prevTouches, curTouches, nOpenedFingers) => {
    let prevPositions = [];
    let curPositions = [];
    let directions = [];
    let intercepts = [];
    let slopes = [];
    const INCREMENT_STEP = INTERPOLATION_INCREMENT_STEP;
    // prevTouches.length correspond to number of fingers
    for (let i = 0; i < prevTouches.length; i++) {
      const prevTouch = prevTouches[i];
      const curTouch = curTouches[i];
      if (curTouch === null || prevTouch === null) {
        if (prevTouch !== null) {
          prevPositions.push([prevTouch.clientX, prevTouch.clientY]);
        } else {
          prevPositions.push(null);
        }
        curPositions.push(null);
        directions.push(null);
        intercepts.push(null);
        slopes.push(null);
        continue;
      }
      const prevX = prevTouch.clientX;
      const prevY = prevTouch.clientY;
      const curX = curTouch.clientX;
      const curY = curTouch.clientY;
      const slope = this.calculateSlope(prevX, prevY, curX, curY);
      const intercept = slope === INFINITE_SLOPE ? null : prevY - slope * prevX;
      prevPositions.push([prevX, prevY]);
      curPositions.push([curX, curY]);
      intercepts.push(intercept);
      slopes.push(slope);
      // If slope is infinite, then only y co-ordinate needs to be changed
      if (slope === INFINITE_SLOPE) {
        if (curY < prevY) {
          directions.push(-1);
        } else {
          directions.push(1);
        }
      } else {
        if (curX < prevX) {
          directions.push(-1);
        } else if (prevX < curX) {
          directions.push(1);
        }
      }
    }
    // ProcessedFingers indicate the number of fingers that have reached the target end touch
    // Example: indexFinger: (x1, y1), middleFinger: (x2, y2), ringFinger: (x3, y2), pinky: (x4, y2)
    // We process the touches in an incremental manner
    // indexFinger: (x1, y1) -> (x1 + INCREMENT_STEP, y1') -> (x1 + 2*INCREMENT_STEP, y1'') -> ...
    // middleFinger: (x2, y2) -> (x2 + INCREMENT_STEP, y2') -> (x2 + 2*INCREMENT_STEP, y2'') -> ...
    // The target touch for each finger is reached when x co-ordinate reaches the endTouch[0]
    // At that time, we increment processedFingers by 1, since that finger has no more touch to be
    // interpolated
    let processedFingers = 0;

    while (processedFingers < nOpenedFingers) {
      processedFingers = 0;
      let touches = [];
      for (let i = 0; i < prevTouches.length; i++) {
        if (prevTouches[i] !== null && curTouches[i] === null) {
          // trigger touchend event
          const x = prevPositions[i][0];
          const y = prevPositions[i][1];
          let touchEnd = new Touch({ identifier: i, clientX: x, clientY: y, target: window });
          let touchEvent = new TouchEvent(TOUCH_END, {
            touches: [],
            view: window,
            cancelable: true,
            changedTouches: [touchEnd],
          });
          // this.state.pendingTouches.push(touchEvent);
          this.playTouchEventSound(touchEvent);
          processedFingers += 1;
          continue;
        }
        if (!prevPositions[i] || !curPositions[i]) {
          processedFingers += 1;
          continue;
        }
        if (directions[i] === 1) {
          if (slopes[i] === INFINITE_SLOPE && prevPositions[i][1] >= curPositions[i][1]) {
            processedFingers += 1;
            continue;
          } else if (slopes[i] !== INFINITE_SLOPE && prevPositions[i][0] >= curPositions[i][0]) {
            processedFingers += 1;
            continue;
          }
        } else if (directions[i] === -1) {
          if (slopes[i] === INFINITE_SLOPE && prevPositions[i][1] <= curPositions[i][1]) {
            processedFingers += 1;
            continue;
          } else if (slopes[i] !== INFINITE_SLOPE && prevPositions[i][0] <= curPositions[i][0]) {
            processedFingers += 1;
            continue;
          }
        }
        let increment = directions[i] * INCREMENT_STEP;
        if (slopes[i] === INFINITE_SLOPE) {
          const x = prevPositions[i][0];
          const y = prevPositions[i][1];
          const nextY = y + increment;
          prevPositions[i][1] = nextY;
          touches.push(new Touch({ identifier: i, clientX: x, clientY: y, target: window }));
        } else {
          const x = prevPositions[i][0];
          const y = prevPositions[i][1];
          const nextX = x + increment;
          const nextY = intercepts[i] + slopes[i] * nextX;
          prevPositions[i][0] = nextX;
          prevPositions[i][1] = nextY;
          touches.push(new Touch({ identifier: i, clientX: x, clientY: y, target: window }));
        }
      }
      if (touches.length > 0) {
        let touchesCopy = [...touches];
        let touchEvent = new TouchEvent(TOUCH_MOVE, {
          touches: touchesCopy,
          view: window,
          cancelable: true,
          changedTouches: touchesCopy,
        });
        this.playTouchEventSound(touchEvent);
      }
    }

    // Play the curTouch
    let curTouchesArr = [];
    for (let i = 0; i < curTouches.length; i++) {
      if (!curPositions[i]) {
        continue;
      }
      const x = curPositions[i][0];
      const y = curPositions[i][1];
      curTouchesArr.push(new Touch({ identifier: i, clientX: x, clientY: y, target: window }));
    }
    if (curTouchesArr.length > 0) {
      let curTouchesArrCopy = [...curTouchesArr];
      let touchEvent = new TouchEvent(TOUCH_MOVE, {
        touches: curTouchesArrCopy,
        view: window,
        cancelable: true,
        changedTouches: curTouchesArrCopy,
      });
      // this.state.pendingTouches.push(touchEvent);
      this.playTouchEventSound(touchEvent);
    }
    return;
  };

  // Detect fingers which are opened and interpolate the points between
  // two consecutive detections of fingers' tips
  triggerMultiTouchEventsWithOnlyOpenedFingersAndInterpolation = (predictions) => {
    if (predictions.length > 0) {
      // Get the first prediction
      let prediction = predictions[0];
      // Grab landmarks
      const landmarks = prediction.landmarks;
      // Find the opened fingers
      const openedFingers = this.detectOpenedFingers(landmarks);
      // Initialize the finger touch locations with -1
      let fingerTouchLocations = [];
      for (let i = 0; i < 2 * Object.keys(fingerJoints).length; i++) {
        fingerTouchLocations.push(-1);
      }
      // Loop through each opened finger
      for (let i = 0; i < openedFingers.length; i++) {
        const finger = openedFingers[i]; // get the finger (eg. 'thumb')
        if (finger === 'thumb') {
          continue;
        }
        // Get the last index of the 5 keyjoints of each finger
        const jointIndex = fingerJoints[finger][fingerJoints[finger].length - 1];
        // Draw the touch on the webcam canvas
        this.webCamRef.current.drawFingerJoint(landmarks[jointIndex][0], landmarks[jointIndex][1]);
        // Scale x and y
        // Subtract from this.canvas.width since the location coordinates obtained is as per lateral inversion
        let touchLocationX =
          this.canvas.width - (landmarks[jointIndex][0] / WEB_CAM_WIDTH) * this.canvas.width;
        let touchLocationY = Math.min(
          this.canvas.height,
          (landmarks[jointIndex][1] / WEB_CAM_HEIGHT1) * this.canvas.height
        );
        // Index 2*fingerIdxMapping[finger] will store x coordinate and next index will store y coordinate
        fingerTouchLocations[2 * fingerIdxMapping[finger]] = touchLocationX;
        fingerTouchLocations[2 * fingerIdxMapping[finger] + 1] = touchLocationY;
      }
      let touches = [];
      let touchesCopy = [];
      for (let i = 0; i < 2 * Object.keys(fingerJoints).length; i += 2) {
        // Skip the touch location if its -1
        if (fingerTouchLocations[i] === -1) {
          touches.push(null);
          touchesCopy.push(null);
          continue;
        }
        const x = fingerTouchLocations[i];
        const y = fingerTouchLocations[i + 1];
        touches.push(new Touch({ identifier: i / 2, clientX: x, clientY: y, target: window }));
        // Reason: no getter
        let touchCopy = new Touch({ identifier: i / 2, clientX: x, clientY: y, target: window });
        touchesCopy.push(touchCopy);
      }
      let lastTouches = [...this.lastTriggeredTouches];
      let touchEvent = null;
      if (this.isArrayContentsNull(lastTouches)) {
        // This is the first time touch is triggered hence triggering touchstart event
        let notNullTouches = this.removeNullFromArray(touches);
        touchEvent = new TouchEvent(TOUCH_START, {
          touches: notNullTouches,
          view: window,
          cancelable: true,
          changedTouches: notNullTouches,
        });
        this.state.pendingTouches.push(touchEvent);
        lastTouches = touchesCopy;
      } else {
        if (lastTouches && lastTouches.length > 0) {
          this.getInterpolatedTouches(lastTouches, touches, openedFingers.length);
          while (lastTouches.length > 0) {
            lastTouches.shift();
          }
        }
        lastTouches = touchesCopy;
      }
      this.lastTriggeredTouches = lastTouches;
    } else {
      // No hand was detected, thus touchend needs to be triggered
      let lastTouches = this.lastTriggeredTouches;
      if (lastTouches && lastTouches.length > 0 && !this.isArrayContentsNull(lastTouches)) {
        let changedTouches = [];
        while (lastTouches.length > 0) {
          let lastTouch = lastTouches.shift();
          if (lastTouch !== null) {
            changedTouches.push(lastTouch);
          }
        }
        const touchEvent = new TouchEvent(TOUCH_END, {
          touches: [],
          view: window,
          cancelable: true,
          changedTouches: changedTouches,
        });
        this.state.pendingTouches.push(touchEvent);
        this.lastTriggeredTouches = lastTouches;
      }
    }
  };

  triggerMouseEvents = (predictions) => {
    if (predictions && predictions.length > 0 && predictions[0].handInViewConfidence > 0.95) {
      // Get the first prediction
      let prediction = predictions[0];
      // Grab landmarks (landmarks contains the location of all keypoints on our hand)
      const landmarks = prediction.keypoints;
      // Get the coordinate of thumb's first keypoint and middle finger's first keypoint
      // By taking the midpoint of both these keypoints coordinates
      let x = (landmarks[0].x + landmarks[9].x) / 2;
      let y = (landmarks[0].y + landmarks[9].y) / 2;
      this.webCamRef.current.drawFingerJoint(x, y);
      // x and y are as per webcam canvas, scale them as per width and height in the spectrogram canvas
      x = this.canvas.width - (x / WEB_CAM_WIDTH) * this.canvas.width;
      y = Math.min(this.canvas.height, (y / WEB_CAM_HEIGHT1) * this.canvas.height);

      this.ctx.beginPath();
      this.ctx.arc(x, y, CANVAS_TOUCH_POINT_SIZE, 0, 3 * Math.PI);
      this.ctx.fillStyle = 'red';
      this.ctx.fill();
      let mouseEvent = null;
      if (!this.webCamMouseDown) {
        // this is the first time hand is detected, trigger mousedown event
        mouseEvent = new MouseEvent(MOUSE_START, {
          clientX: x,
          clientY: y,
          view: window,
          cancelable: true,
        });
        this.webCamMouseDown = true;
      } else {
        // this is not the first time hand is detected, so trigger mousemove event
        mouseEvent = new MouseEvent(MOUSE_MOVE, {
          clientX: x,
          clientY: y,
          view: window,
          cancelable: true,
        });
      }
      this.playMouseEventSound(mouseEvent);
    } else {
      // No hand is detected, reset webCamMouseDown to false if set to true
      // and trigger mouseup event
      if (this.webCamMouseDown) {
        this.webCamMouseDown = false;
        let mouseEvent = new MouseEvent(MOUSE_END, {
          view: window,
          cancelable: true,
        });
        this.playMouseEventSound(mouseEvent);
      }
    }
  };

  // Renders one column of the spectrogram on timer
  renderFreqDomain = () => {
    let { width, height, log, resolutionMax, resolutionMin, speed } = this.context.state;
    let freq = new Uint8Array(analyser.frequencyBinCount);
    analyser.getByteFrequencyData(freq);
    this.tempCtx = this.tempCanvas.getContext('2d');
    this.tempCanvas.width = width;
    this.tempCanvas.height = height;
    this.tempCtx.drawImage(this.canvas, 0, 0, width, height);

    // Iterate over the frequencies.
    for (var i = 0; i < height; i++) {
      var value;
      // Draw each pixel with the specific color.

      // Gets the height and creates a log scale of the index
      if (log) {
        let myPercent = i / height;
        var logPercent = getFreq(myPercent, resolutionMin, resolutionMax);
        let logIndex = Math.round((logPercent * freq.length) / (audioContext.sampleRate / 2));
        value = freq[logIndex];
      } else {
        let myPercent = i / height;
        let newPercent =
          Math.floor(myPercent * (resolutionMax - resolutionMin) + resolutionMin) + 1;
        let logIndex = Math.round((newPercent * freq.length) / (audioContext.sampleRate / 2));
        value = freq[logIndex];
      }

      this.ctx.fillStyle = this.getColor(value);
      var percent = i / height;
      var y = Math.round(percent * height);
      this.ctx.fillRect(width - speed, height - y - speed / 2 - 2, speed, speed);
    }
    // Shifts to left by speed
    this.ctx.translate(-speed, 0);
    this.ctx.drawImage(this.tempCanvas, 0, 0, width, height, 0, 0, width, height);
    // Resets transformation
    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
  };

  // Helper function that converts frequency value to color
  getColor(value) {
    // Test Max
    if (value === 255) {
      console.log('MAX!');
    }
    let percent = (value / 255) * 50;
    // return 'rgb(V, V, V)'.replace(/V/g, 255 - value);
    return 'hsl(H, 100%, P%)'.replace(/H/g, 255 - value).replace(/P/g, percent);
  }

  // Pre-compute RGBA color lookup table for all 256 byte values
  initColorLUT() {
    this.colorLUT = new Uint8Array(256 * 4);
    for (let i = 0; i < 256; i++) {
      const hue = (255 - i) / 360 * 360; // hue in degrees
      const lightness = (i / 255) * 50 / 100; // lightness as 0-1
      const saturation = 1.0;

      // HSL to RGB conversion
      const c = (1 - Math.abs(2 * lightness - 1)) * saturation;
      const x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
      const m = lightness - c / 2;
      let r, g, b;
      if (hue < 60) { r = c; g = x; b = 0; }
      else if (hue < 120) { r = x; g = c; b = 0; }
      else if (hue < 180) { r = 0; g = c; b = x; }
      else if (hue < 240) { r = 0; g = x; b = c; }
      else if (hue < 300) { r = x; g = 0; b = c; }
      else { r = c; g = 0; b = x; }

      this.colorLUT[i * 4] = Math.round((r + m) * 255);
      this.colorLUT[i * 4 + 1] = Math.round((g + m) * 255);
      this.colorLUT[i * 4 + 2] = Math.round((b + m) * 255);
      this.colorLUT[i * 4 + 3] = 255;
    }
  }

  handleHeadphoneModeToggle = () => this.context.handleHeadphoneModeToggle();

  handleMicrophoneToggle = () => this.context.handleMicrophoneToggle();

  spacePressed = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      this.context.handlePause();
    }
  };

  handleResize = () => {
    this.context.handleResize();
    if (this.soundMakingRef.current && this.context.state.noteLinesOn === true) {
      this.soundMakingRef.current.removeNoteLines()
      this.soundMakingRef.current.renderNoteLines();
    }
  };

  // Toggle modal window (instructions to allow microphone)
  handleModalToggle = () => this.context.handleModalToggle();
  // Close instructions
  handleInstructionsClose = () => {
    this.context.handleInstructionsClose();
  };

  // addToHomeScreen = () =>{
  //   this.state.deferredPrompt.prompt();
  //   // Wait for the user to respond to the prompt
  //   this.state.deferredPrompt.userChoice
  //     .then((choiceResult) => {
  //       if (choiceResult.outcome === 'accepted') {
  //         console.log('User accepted the A2HS prompt');
  //       } else {
  //         console.log('User dismissed the A2HS prompt');
  //       }
  //       this.setState({deferredPrompt: null});
  //     });
  // }

  handleWebCamEnabled = (flag) => {
    this.setState({ webCamEnabled: flag });
  };

  toggleRecording = () => {
    if (this.isRecording) {
      this.stopRecording();
    } else {
      this.startRecording();
    }
  };

  startRecording = () => {
    if (!audioContext || !analyser) {
      console.warn('Audio context not ready for recording');
      return;
    }

    // Initialize incremental FFT processing state
    this.recordingSampleRate = audioContext?.sampleRate || 44100;
    this.recordingBuffer = new Float32Array(this.recordingSampleRate * 120); // pre-allocate for 2 minutes
    this.recordingBufferLength = 0;
    this.processedSampleCount = 0;
    this.incrementalMagnitudes = [];

    // Create ScriptProcessorNode to capture audio samples
    const bufferSize = 4096;
    this.scriptProcessor = audioContext.createScriptProcessor(bufferSize, 1, 1);

    this.scriptProcessor.onaudioprocess = (e) => {
      if (this.isRecording) {
        const inputData = e.inputBuffer.getChannelData(0);
        const len = inputData.length;

        // Grow buffer if needed
        if (this.recordingBufferLength + len > this.recordingBuffer.length) {
          const newBuffer = new Float32Array(this.recordingBuffer.length * 2);
          newBuffer.set(this.recordingBuffer.subarray(0, this.recordingBufferLength));
          this.recordingBuffer = newBuffer;
        }
        this.recordingBuffer.set(inputData, this.recordingBufferLength);
        this.recordingBufferLength += len;
      }
    };

    // Connect: analyser -> scriptProcessor -> destination
    analyser.connect(this.scriptProcessor);
    this.scriptProcessor.connect(audioContext.destination);

    // Start incremental FFT processing every 2 seconds
    this.incrementalProcessingTimer = setInterval(() => {
      this.processIncrementalFFT();
    }, 2000);

    this.isRecording = true;
    this.setState({ recording: true });
    console.log('Recording started');
  };

  // Process any new audio samples that have accumulated since last processing
  processIncrementalFFT = () => {
    const fftSize = this.context.state.fftSize || defaultFftSize;
    const availableFrames = Math.floor(
      (this.recordingBufferLength - this.processedSampleCount) / fftSize
    );
    if (availableFrames === 0) return;

    const fftObj = new FFT(fftSize);
    const complexOut = fftObj.createComplexArray();
    const complexIn = fftObj.createComplexArray();

    for (let i = 0; i < availableFrames; i++) {
      const startSample = this.processedSampleCount + i * fftSize;

      for (let j = 0; j < fftSize; j++) {
        complexIn[2 * j] = this.recordingBuffer[startSample + j];
        complexIn[2 * j + 1] = 0;
      }

      fftObj.transform(complexOut, complexIn);

      const magnitudes = new Float32Array(fftSize / 2);
      for (let j = 0; j < fftSize / 2; j++) {
        const real = complexOut[2 * j];
        const imag = complexOut[2 * j + 1];
        magnitudes[j] = Math.sqrt(real * real + imag * imag);
      }
      this.incrementalMagnitudes.push(magnitudes);
    }

    this.processedSampleCount += availableFrames * fftSize;
    console.log(`Incremental FFT: processed ${availableFrames} frames, total columns: ${this.incrementalMagnitudes.length}`);
  };

  stopRecording = () => {
    this.isRecording = false;
    this.setState({ recording: false });

    // Stop incremental processing timer
    if (this.incrementalProcessingTimer) {
      clearInterval(this.incrementalProcessingTimer);
      this.incrementalProcessingTimer = null;
    }

    // Disconnect script processor
    if (this.scriptProcessor) {
      try {
        analyser.disconnect(this.scriptProcessor);
        this.scriptProcessor.disconnect();
      } catch (e) {
        // Ignore errors
      }
      this.scriptProcessor = null;
    }

    if (this.recordingBufferLength > 0) {
      // Process any remaining samples that haven't been FFT'd yet
      this.processIncrementalFFT();

      const audioData = this.recordingBuffer.slice(0, this.recordingBufferLength);

      // Build spectrogram from pre-computed magnitudes and add to recordings
      this.addRecording(audioData);

      this.setState(prev => ({
        hasRecording: true,
        recordingCount: prev.recordingCount + 1
      }));
    }
  };

  // Add a new recording to the recordings array and update combined spectrogram
  // Uses pre-computed magnitudes from incremental FFT + ImageData for fast rendering
  addRecording = (audioData) => {
    const { height, log, resolutionMax, resolutionMin } = this.context.state;
    const numColumns = this.incrementalMagnitudes.length;
    const duration = audioData.length / this.recordingSampleRate;

    console.log(`Adding recording: ${numColumns} columns, duration: ${duration.toFixed(2)}s`);
    console.time('Spectrogram rendering');

    // Create offscreen canvas for this recording's spectrogram
    const spectrogramCanvas = document.createElement('canvas');
    spectrogramCanvas.width = numColumns;
    spectrogramCanvas.height = height;
    const gctx = spectrogramCanvas.getContext('2d');

    // Render all columns using ImageData + color LUT (batch pixel write)
    const imageData = gctx.createImageData(numColumns, height);
    const pixels = imageData.data;
    const halfSampleRate = this.recordingSampleRate / 2;
    const minDecibels = -30;
    const maxDecibels = 50;
    const dbRange = maxDecibels - minDecibels;

    for (let col = 0; col < numColumns; col++) {
      const magnitudes = this.incrementalMagnitudes[col];

      for (let y = 0; y < height; y++) {
        let magnitude;
        const percent = y / height;

        if (log) {
          const logPercent = getFreq(percent, resolutionMin, resolutionMax);
          const binIndex = Math.round((logPercent * magnitudes.length) / halfSampleRate);
          magnitude = magnitudes[Math.min(binIndex, magnitudes.length - 1)] || 0;
        } else {
          const freqPercent = Math.floor(percent * (resolutionMax - resolutionMin) + resolutionMin) + 1;
          const binIndex = Math.round((freqPercent * magnitudes.length) / halfSampleRate);
          magnitude = magnitudes[Math.min(binIndex, magnitudes.length - 1)] || 0;
        }

        // Convert to dB and byte value
        const dbValue = 20 * Math.log10(magnitude + 1e-10);
        const byteValue = Math.max(0, Math.min(255,
          (255 * (dbValue - minDecibels) / dbRange) | 0
        ));

        // Write RGBA directly from color LUT
        const lutIdx = byteValue * 4;
        const pixelIdx = ((height - y - 1) * numColumns + col) * 4;
        pixels[pixelIdx] = this.colorLUT[lutIdx];
        pixels[pixelIdx + 1] = this.colorLUT[lutIdx + 1];
        pixels[pixelIdx + 2] = this.colorLUT[lutIdx + 2];
        pixels[pixelIdx + 3] = 255;
      }
    }

    gctx.putImageData(imageData, 0, 0);
    console.timeEnd('Spectrogram rendering');

    // Create audio buffer for this recording
    const audioBuffer = audioContext.createBuffer(1, audioData.length, this.recordingSampleRate);
    audioBuffer.copyToChannel(audioData, 0, 0);

    // Calculate start column (after existing recordings)
    const startColumn = this.totalColumns;

    // Create recording object and add to array
    const recording = {
      audioBuffer,
      spectrogramCanvas,
      duration,
      sampleRate: this.recordingSampleRate,
      startColumn,
      columnCount: numColumns,
      audioData: audioData.slice() // Keep a copy of raw audio data
    };

    this.recordings.push(recording);
    this.totalColumns += numColumns;

    // Update combined spectrogram canvas
    this.updateCombinedSpectrogram();

    // Clear incremental state
    this.incrementalMagnitudes = [];
    this.processedSampleCount = 0;

    console.log(`Recording added. Total recordings: ${this.recordings.length}, Total columns: ${this.totalColumns}`);
  };

  // Rebuild the combined spectrogram canvas from all recordings
  updateCombinedSpectrogram = () => {
    if (this.recordings.length === 0) {
      this.combinedSpectrogramCanvas = null;
      return;
    }

    const { height } = this.context.state;

    // Create combined canvas
    this.combinedSpectrogramCanvas = document.createElement('canvas');
    this.combinedSpectrogramCanvas.width = this.totalColumns;
    this.combinedSpectrogramCanvas.height = height;
    const ctx = this.combinedSpectrogramCanvas.getContext('2d');

    // Draw each recording's spectrogram
    for (const recording of this.recordings) {
      ctx.drawImage(
        recording.spectrogramCanvas,
        recording.startColumn, 0
      );
    }

    console.log(`Combined spectrogram updated: ${this.totalColumns} x ${height}`);
  };

  // Get the total duration of all recordings combined
  getTotalRecordingsDuration = () => {
    return this.recordings.reduce((sum, rec) => sum + rec.duration, 0);
  };

  // Get which recording and local position a global position maps to
  getRecordingAtPosition = (globalPosition) => {
    if (this.recordings.length === 0) return null;

    const globalColumn = Math.floor(globalPosition * this.totalColumns);

    for (let i = 0; i < this.recordings.length; i++) {
      const rec = this.recordings[i];
      if (globalColumn >= rec.startColumn && globalColumn < rec.startColumn + rec.columnCount) {
        const localColumn = globalColumn - rec.startColumn;
        const localPosition = localColumn / rec.columnCount;
        return {
          recordingIndex: i,
          recording: rec,
          localPosition,
          localColumn
        };
      }
    }

    // If past the end, return last recording at end
    const lastRec = this.recordings[this.recordings.length - 1];
    return {
      recordingIndex: this.recordings.length - 1,
      recording: lastRec,
      localPosition: 1,
      localColumn: lastRec.columnCount
    };
  };

  // Clear all recordings
  clearAllRecordings = () => {
    this.stopRecordedAudioPlayback();
    this.recordings = [];
    this.totalColumns = 0;
    this.combinedSpectrogramCanvas = null;
    this.setState({
      hasRecording: false,
      recordingCount: 0,
      showRecordedSpectrogram: false,
      recordingScrollPosition: 0,
      clipSelection: null
    });
  };

  // Toggle viewing the recorded spectrogram
  toggleRecordedSpectrogram = () => {
    this.setState(prev => ({
      showRecordedSpectrogram: !prev.showRecordedSpectrogram,
      recordingScrollPosition: !prev.showRecordedSpectrogram ? 0 : prev.recordingScrollPosition
    }));
  };

  // Handle scroll position change
  handleRecordingScroll = (e) => {
    const newPosition = parseFloat(e.target.value);

    // If playing, stop
    if (this.state.scrollbarPlaying) {
      this.stopRecordedAudioPlayback();
      this.setState({
        scrollbarPlaying: false,
        recordingScrollPosition: newPosition
      });
    } else {
      this.setState({ recordingScrollPosition: newPosition });
    }
  };

  // Get total duration of all recordings in seconds
  getRecordingDuration = () => {
    return this.getTotalRecordingsDuration();
  };

  playRecordingScroll = () => {
    if (this.recordings.length === 0) return;

    this.stopRecordedAudioPlayback();

    // If at the end, reset to beginning
    let currentPosition = this.state.recordingScrollPosition;
    if (currentPosition >= 1) {
      currentPosition = 0;
      this.setState({ recordingScrollPosition: 0 });
    }

    // Resume audio context if suspended
    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }

    // Calculate where we are in the combined timeline
    const totalDuration = this.getRecordingDuration();
    const startOffset = currentPosition * totalDuration;

    // Store when we started and from what offset (for tracking position)
    this.playbackContextStartTime = audioContext.currentTime;
    this.playbackAudioOffset = startOffset;

    // Schedule all recordings to play at the appropriate times
    this.scheduledSources = [];
    let accumulatedTime = 0;

    for (const recording of this.recordings) {
      const recordingStart = accumulatedTime;
      const recordingEnd = accumulatedTime + recording.duration;

      // Check if this recording should play
      if (startOffset < recordingEnd) {
        const source = audioContext.createBufferSource();
        source.buffer = recording.audioBuffer;
        source.connect(audioContext.destination);

        if (startOffset > recordingStart) {
          // Start from middle of this recording
          const localOffset = startOffset - recordingStart;
          source.start(0, localOffset);
        } else {
          // Schedule to play after earlier recordings
          const delay = recordingStart - startOffset;
          source.start(audioContext.currentTime + delay);
        }

        this.scheduledSources.push(source);
      }

      accumulatedTime += recording.duration;
    }

    this.setState({ scrollbarPlaying: true });

    // Set up ended handler on the last source
    if (this.scheduledSources.length > 0) {
      const lastSource = this.scheduledSources[this.scheduledSources.length - 1];
      lastSource.onended = () => {
        if (this.state.scrollbarPlaying) {
          this.setState({ scrollbarPlaying: false, recordingScrollPosition: 1 });
        }
      };
    }
  };

  pauseRecordingScroll = () => {
    if (!this.state.scrollbarPlaying) return;

    // Calculate current position before stopping
    const currentPosition = this.getCurrentPlaybackPosition();

    this.stopRecordedAudioPlayback();
    this.setState({
      scrollbarPlaying: false,
      recordingScrollPosition: currentPosition
    });
  };

  // Get current playback position as a 0-1 value
  getCurrentPlaybackPosition = () => {
    if (!this.state.scrollbarPlaying) {
      return this.state.recordingScrollPosition;
    }

    const totalDuration = this.getRecordingDuration();
    if (totalDuration === 0) return 0;

    // Time elapsed since we started this playback
    const elapsed = audioContext.currentTime - this.playbackContextStartTime;
    // Current position in audio = where we started + time elapsed
    const currentTime = this.playbackAudioOffset + elapsed;

    return Math.min(1, Math.max(0, currentTime / totalDuration));
  };

  stopRecordedAudioPlayback = () => {
    // Stop all scheduled sources
    if (this.scheduledSources) {
      for (const source of this.scheduledSources) {
        try {
          source.stop();
          source.disconnect();
        } catch (e) {
          // Ignore errors if already stopped
        }
      }
      this.scheduledSources = [];
    }
  };

  // Render the recorded spectrogram to the main canvas
  renderRecordedSpectrogram = () => {
    if (!this.combinedSpectrogramCanvas || !this.ctx) return;

    const { width, height, speed } = this.context.state;
    const srcWidth = this.combinedSpectrogramCanvas.width;
    const srcHeight = this.combinedSpectrogramCanvas.height;

    // Clear canvas
    this.ctx.fillStyle = '#000';
    this.ctx.fillRect(0, 0, width, height);

    // Use the same speed as the live spectrogram
    const pixelsPerColumn = speed || 15;
    const colsPerScreen = Math.ceil(width / pixelsPerColumn);
    const currentPosition = this.state.recordingScrollPosition;
    const currentColumn = Math.floor(currentPosition * srcWidth);

    const colsBeforePlayhead = Math.floor(colsPerScreen / 2);

    // Calculate srcStartX and playheadX based on position in recording
    let srcStartX;
    let playheadX;

    if (currentColumn < colsBeforePlayhead) {
      // At the beginning - playhead scrolls from left to middle
      srcStartX = 0;
      playheadX = currentColumn * pixelsPerColumn;
    } else if (currentColumn > srcWidth - colsBeforePlayhead) {
      // At the end - playhead scrolls from middle to right
      srcStartX = Math.max(0, srcWidth - colsPerScreen);
      playheadX = (currentColumn - srcStartX) * pixelsPerColumn;
    } else {
      // In the middle - playhead stays in center
      srcStartX = currentColumn - colsBeforePlayhead;
      playheadX = colsBeforePlayhead * pixelsPerColumn;
    }

    // Draw the spectrogram
    const srcCols = Math.min(colsPerScreen, srcWidth - srcStartX);
    const destWidth = srcCols * pixelsPerColumn;

    // Disable image smoothing to get sharp column edges
    this.ctx.imageSmoothingEnabled = false;

    this.ctx.drawImage(
      this.combinedSpectrogramCanvas,
      srcStartX, 0, srcCols, srcHeight,  // source rectangle
      0, 0, destWidth, height            // destination rectangle
    );

    // Re-enable smoothing for other drawing operations
    this.ctx.imageSmoothingEnabled = true;

    // Draw recording boundaries (vertical lines between recordings)
    this.ctx.strokeStyle = 'rgba(255, 0, 0, 1)';
    this.ctx.lineWidth = 3;
    for (const recording of this.recordings) {
      if (recording.startColumn > 0) {
        const boundaryX = (recording.startColumn - srcStartX) * pixelsPerColumn;
        if (boundaryX > 0 && boundaryX < width) {
          this.ctx.beginPath();
          this.ctx.setLineDash([5, 5]);
          this.ctx.moveTo(boundaryX, 0);
          this.ctx.lineTo(boundaryX, height);
          this.ctx.stroke();
          this.ctx.setLineDash([]);
        }
      }
    }

    // Draw vertical playhead line
    this.ctx.strokeStyle = this.state.scrollbarPlaying ? '#00ff00' : '#ffff00';
    this.ctx.lineWidth = 2;
    this.ctx.beginPath();
    this.ctx.moveTo(playheadX, 0);
    this.ctx.lineTo(playheadX, height);
    this.ctx.stroke();

    this.renderClipSelection(srcStartX, srcWidth, pixelsPerColumn, height);
  };

  canvasXToPosition = (canvasX) => {
    if (!this.combinedSpectrogramCanvas) {
      console.log('No combined spectrogram canvas');
      return 0;
    }
    const { width, speed } = this.context.state;
    const srcWidth = this.combinedSpectrogramCanvas.width;
    const pixelsPerColumn = speed || 15;
    const colsPerScreen = Math.ceil(width / pixelsPerColumn);
    const colsBeforePlayhead = Math.floor(colsPerScreen / 2);
    const currentPosition = this.state.recordingScrollPosition;
    const currentColumn = Math.floor(currentPosition * srcWidth);
    let srcStartX;
    if (currentColumn < colsBeforePlayhead) {
      srcStartX = 0;
    } else if (currentColumn > srcWidth - colsBeforePlayhead) {
      srcStartX = Math.max(0, srcWidth - colsPerScreen);
    } else {
      srcStartX = currentColumn - colsBeforePlayhead;
    }

    // Convert canvas X to source column, then to normalized position
    const column = srcStartX + (canvasX / pixelsPerColumn);
    const position = Math.max(0, Math.min(1, column / srcWidth));
    console.log('canvasXToPosition:', { canvasX, column, srcWidth, position });
    return position;
  };

  handleClipSelectionStart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const rect = this.clipOverlayCanvas.getBoundingClientRect();
    const canvasX = e.clientX - rect.left;

    this.isSelectingClip = true;
    this.clipDragStartX = canvasX;

    const position = this.canvasXToPosition(canvasX);
    this.setState({ clipSelection: { start: position, end: position } });
  };

  handleClipSelectionMove = (e) => {
    if (!this.isSelectingClip || !this.state.clipSelection) return;
    const rect = this.clipOverlayCanvas.getBoundingClientRect();
    const canvasX = e.clientX - rect.left;
    const position = this.canvasXToPosition(canvasX);
    const startPos = this.canvasXToPosition(this.clipDragStartX);

    // Ensure start < end
    this.setState({
      clipSelection: {
        start: Math.min(startPos, position),
        end: Math.max(startPos, position)
      }
    });
  };

  handleClipSelectionEnd = (e) => {
    if (!this.isSelectingClip) return;
    this.isSelectingClip = false;

    // If selection is too small, clear it
    if (this.state.clipSelection) {
      const { start, end } = this.state.clipSelection;
      const size = Math.abs(end - start);
      if (size < 0.005) {
        this.setState({ clipSelection: null });
      }
    }
  };

  clearClipSelection = () => {
    this.setState({ clipSelection: null });
  };

  renderClipSelection = (srcStartX, srcWidth, pixelsPerColumn, height) => {
    if (!this.state.clipSelection || !this.ctx) return;

    const { start, end } = this.state.clipSelection;
    const { width } = this.context.state;

    const startColumn = Math.floor(start * srcWidth);
    const endColumn = Math.floor(end * srcWidth);
    const startCanvasX = (startColumn - srcStartX) * pixelsPerColumn;
    const endCanvasX = (endColumn - srcStartX) * pixelsPerColumn;

    // Clip to visible area
    const visibleStartX = Math.max(0, startCanvasX);
    const visibleEndX = Math.min(width, endCanvasX);

    if (visibleEndX <= visibleStartX) return;

    // Draw semi-transparent selection overlay
    this.ctx.fillStyle = 'rgba(0, 150, 255, 0.3)';
    this.ctx.fillRect(visibleStartX, 0, visibleEndX - visibleStartX, height);

    // Draw selection boundaries
    this.ctx.strokeStyle = '#00aaff';
    this.ctx.lineWidth = 2;

    // Left boundary
    if (startCanvasX >= 0 && startCanvasX <= width) {
      this.ctx.beginPath();
      this.ctx.moveTo(startCanvasX, 0);
      this.ctx.lineTo(startCanvasX, height);
      this.ctx.stroke();
    }

    // Right boundary
    if (endCanvasX >= 0 && endCanvasX <= width) {
      this.ctx.beginPath();
      this.ctx.moveTo(endCanvasX, 0);
      this.ctx.lineTo(endCanvasX, height);
      this.ctx.stroke();
    }
  };

  // Get the selected clip's time range in seconds
  getClipTimeRange = () => {
    if (!this.state.clipSelection || this.recordings.length === 0) return null;
    const { start, end } = this.state.clipSelection;
    const duration = this.getTotalRecordingsDuration();
    return {
      startTime: start * duration,
      endTime: end * duration,
      duration: (end - start) * duration
    };
  };

  // Get combined audio buffer from all recordings for the selected clip range
  getClipAudioData = () => {
    const range = this.getClipTimeRange();
    if (!range || this.recordings.length === 0) return null;

    const { startTime, endTime } = range;
    const sampleRate = this.recordings[0].sampleRate;

    // Calculate which recordings and samples are included in the selection
    const clipSamples = [];
    let accumulatedTime = 0;

    for (const recording of this.recordings) {
      const recordingStart = accumulatedTime;
      const recordingEnd = accumulatedTime + recording.duration;

      // Check if this recording overlaps with the selection
      if (startTime < recordingEnd && endTime > recordingStart) {
        const localStartTime = Math.max(0, startTime - recordingStart);
        const localEndTime = Math.min(recording.duration, endTime - recordingStart);

        const startSample = Math.floor(localStartTime * recording.sampleRate);
        const endSample = Math.floor(localEndTime * recording.sampleRate);

        const channelData = recording.audioBuffer.getChannelData(0);
        clipSamples.push(channelData.slice(startSample, endSample));
      }

      accumulatedTime += recording.duration;
    }

    // Combine all samples into one array
    const totalLength = clipSamples.reduce((sum, arr) => sum + arr.length, 0);
    const combinedData = new Float32Array(totalLength);
    let offset = 0;
    for (const samples of clipSamples) {
      combinedData.set(samples, offset);
      offset += samples.length;
    }

    return { audioData: combinedData, sampleRate };
  };

  // Play or pause the selected clip
  toggleClipPlayback = () => {
    if (this.state.clipPlaying) {
      this.stopClipPlayback();
    } else {
      this.playClip();
    }
  };

  playClip = () => {
    const range = this.getClipTimeRange();
    if (!range || this.recordings.length === 0) return;

    // Stop any existing playback
    this.stopClipPlayback();

    // Resume audio context if suspended
    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }

    // Calculate where the clip starts and ends in the combined timeline
    const { startTime, endTime } = range;

    // Schedule playback of each recording's relevant portion
    this.clipScheduledSources = [];
    let accumulatedTime = 0;

    for (const recording of this.recordings) {
      const recordingStart = accumulatedTime;
      const recordingEnd = accumulatedTime + recording.duration;

      // Check if this recording overlaps with the selection
      if (startTime < recordingEnd && endTime > recordingStart) {
        const source = audioContext.createBufferSource();
        source.buffer = recording.audioBuffer;
        source.connect(audioContext.destination);

        const localStartTime = Math.max(0, startTime - recordingStart);
        const localEndTime = Math.min(recording.duration, endTime - recordingStart);
        const localDuration = localEndTime - localStartTime;

        // Calculate when to start this source
        const delayBeforeStart = Math.max(0, recordingStart - startTime);

        source.start(audioContext.currentTime + delayBeforeStart, localStartTime, localDuration);
        this.clipScheduledSources.push(source);
      }

      accumulatedTime += recording.duration;
    }

    this.setState({ clipPlaying: true });

    // Set up ended handler on the last source
    if (this.clipScheduledSources.length > 0) {
      const lastSource = this.clipScheduledSources[this.clipScheduledSources.length - 1];
      lastSource.onended = () => {
        this.setState({ clipPlaying: false });
      };
    }
  };

  stopClipPlayback = () => {
    // Stop all scheduled clip sources
    if (this.clipScheduledSources) {
      for (const source of this.clipScheduledSources) {
        try {
          source.stop();
          source.disconnect();
        } catch (e) {
          // Already stopped
        }
      }
      this.clipScheduledSources = [];
    }


    this.setState({ clipPlaying: false });
  };

  // Show save prompt
  openSavePrompt = () => {
    this.setState({ showSavePrompt: true, clipLabel: '' });
  };

  closeSavePrompt = () => {
    this.setState({ showSavePrompt: false, clipLabel: '' });
  };

  handleClipLabelChange = (e) => {
    this.setState({ clipLabel: e.target.value });
  };

  // Save the selected clip as a WAV file - can be adjusted later for ML work
  saveClip = () => {
    const clipAudioData = this.getClipAudioData();
    if (!clipAudioData) return;

    const { audioData, sampleRate } = clipAudioData;

    // Create WAV file
    const wavBlob = this.createWavBlob(audioData, sampleRate);

    // Generate filename
    const label = this.state.clipLabel.trim() || 'clip';
    const filename = `${label.replace(/[^a-z0-9]/gi, '_')}.wav`;

    // Download
    const url = URL.createObjectURL(wavBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);

    if (label && label !== 'clip') {
      this.addLabelToHistory(label);
    }

    this.closeSavePrompt();
  };

  // Create a WAV blob from audio data
  createWavBlob = (audioData, sampleRate) => {
    const numChannels = 1;
    const bitsPerSample = 16;
    const bytesPerSample = bitsPerSample / 8;
    const blockAlign = numChannels * bytesPerSample;
    const byteRate = sampleRate * blockAlign;
    const dataSize = audioData.length * bytesPerSample;
    const bufferSize = 44 + dataSize;

    const buffer = new ArrayBuffer(bufferSize);
    const view = new DataView(buffer);

    // Write WAV header
    const writeString = (offset, string) => {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    };

    writeString(0, 'RIFF');
    view.setUint32(4, bufferSize - 8, true);
    writeString(8, 'WAVE');
    writeString(12, 'fmt ');
    view.setUint32(16, 16, true); // fmt chunk size
    view.setUint16(20, 1, true); // audio format (PCM)
    view.setUint16(22, numChannels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, byteRate, true);
    view.setUint16(32, blockAlign, true);
    view.setUint16(34, bitsPerSample, true);
    writeString(36, 'data');
    view.setUint32(40, dataSize, true);

    // Write audio data
    let offset = 44;
    for (let i = 0; i < audioData.length; i++) {
      const sample = Math.max(-1, Math.min(1, audioData[i]));
      view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
      offset += 2;
    }

    return new Blob([buffer], { type: 'audio/wav' });
  };

  loadSavedLabels = () => {
    try {
      const saved = localStorage.getItem('clipLabels');
      if (saved) {
        const labels = JSON.parse(saved);
        this.setState({ previousLabels: Array.isArray(labels) ? labels : [] });
      }
    } catch (e) {
      console.error('Error loading saved labels:', e);
    }
  };

  saveLablesToLocalStorage = (labels) => {
    try {
      localStorage.setItem('clipLabels', JSON.stringify(labels));
    } catch (e) {
      console.error('Error saving labels:', e);
    }
  };

  // Add a new label to history (keep only unique, most recent ones)
  addLabelToHistory = (label) => {
    let { previousLabels } = this.state;
    // Remove if already exists, then add to front
    previousLabels = previousLabels.filter(l => l !== label);
    previousLabels.unshift(label);
    this.setState({ previousLabels });
    this.saveLablesToLocalStorage(previousLabels);
  };

  getLabelSuggestions = () => {
    const { clipLabel, previousLabels } = this.state;
    if (!clipLabel.trim()) {
      return previousLabels.slice(0, 5); // Show first 5 if empty
    }
    const input = clipLabel.toLowerCase();
    return previousLabels.filter(label =>
      label.toLowerCase().startsWith(input)
    ).slice(0, 5);
  };

  getRecordedAudioBuffer = () => {
    if (!this.recordingBuffer || this.recordingBufferLength === 0) return null;
    return this.recordingBuffer.slice(0, this.recordingBufferLength);
  };

  askWebCamPermission = () => {
    if (this.state.webCamEnabled) {
      this.handleWebCamEnabled(false);
      return;
    }
    if (navigator.mediaDevices.getUserMedia !== null) {
      var options = {
        video: true,
        audio: true,
      };
      navigator.getUserMedia(
        options,
        function (stream) {
          this.handleWebCamEnabled(true);
        }.bind(this),
        function (e) {
          console.log('background error : ' + e.name);
        }
      );
    }
  };

  render() {
    let headphoneStyle = { backgroundColor: '' };
    let microphoneStyle = { backgroundColor: '' };
    if (this.context.state.headphoneMode) {
      headphoneStyle = { backgroundColor: '#2769d8' };
    }
    if (this.context.state.microphone) {
      microphoneStyle = { backgroundColor: '#2769d8' };
    }
    if (this.context.state.midi) {
      microphoneStyle = { backgroundColor: '#2769d8' };
    }

    return (
      <SpectrogramContext.Consumer>
        {(context) => (
          <div>
            <canvas
              id="spectrogramCanvas"
              className="bg-black"
              width={context.state.width}
              height={context.state.height}
              onKeyPress={this.onKeyPress}
              ref={(c) => {
                this.canvas = c;
              }}
            />
            <link rel="preload" href="../midi-red.svg" as="image" />
            <link rel="preload" href="../midi-grey.svg" as="image" />
            <link rel="preload" href="../headphoneSlash.svg" as="image" />

            <link rel="preload" href="../Microphone Permissions 1.png" as="image" />
            <link rel="preload" href="../Microphone Permissions 2.png" as="image" />
            <link rel="preload" href="../Microphone Permissions 3.png" as="image" />

            {context.state.isStarted && (
              <React.Fragment>
                {/* {context.state.freqControls &&
            <FrequencyRange
            resolutionMax={context.state.resolutionMax}
            resolutionMin={context.state.resolutionMin}
            width={context.state.width}
            height={context.state.height}
            handleZoom={context.handleZoom}
            handleResize={this.handleResize}
            noteLinesOn={context.state.noteLinesOn}
            ref={this.frequencyRangeRef}
            />} */}
                <Button icon onClick={context.handlePause} className="pause-button canvas-btn">
                  {!context.state.speed ? (
                    <Icon fitted name="play" color="red" />
                  ) : (
                    <Icon fitted name="pause" color="red" />
                  )}
                </Button>
                {/* <Button
                  icon
                  onClick={this.handleHeadphoneModeToggle}
                  className="headphone-mode-button"
                  style={headphoneStyle}
                >
                  {context.state.headphoneMode ? (
                    <Icon fitted name="headphones" color="red" />
                  ) : (
                    <img
                      src={Logo}
                      height={12.5}
                      width={13.25}
                      className="headphone-slash-logo"
                      alt="headphone slash"
                    />
                  )}
                </Button> */}
                {/* Mic btn */}
                {context.state.micPermission ? (
                  <Button
                    icon
                    onClick={this.handleMicrophoneToggle}
                    id="microphone-mode-button"
                    className="canvas-btn"
                    style={microphoneStyle}
                  >
                    {context.state.microphone ? (
                      <Icon name="microphone" color="red" />
                    ) : (
                      <Icon name="microphone slash" color="red" />
                    )}
                  </Button>
                ) : (
                  <Button
                    icon
                    onClick={this.handleMicrophoneToggle}
                    id="microphone-mode-button"
                    className="pulsing canvas-btn"
                    style={microphoneStyle}
                  >
                    {context.state.microphone ? (
                      <Icon name="microphone" color="red" />
                    ) : (
                      <Icon name="microphone slash" color="red" />
                    )}
                  </Button>
                )}

                <Button
                  className="info-button canvas-btn"
                  href="https://listeningtowaves.com/sound-exploration"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name="info" color="red" className="info-button-icon" />
                </Button>
                <Button
                  icon
                  className="file-upload-button canvas-btn"
                  onClick={() => this.fileUploadRef.current.click()}
                >
                  <Icon fitted name="upload" color="red" />
                  <input
                    type="file"
                    onChange={this.handleFileUpload}
                    value={fileInput}
                    ref={this.fileUploadRef}
                    hidden
                  />
                </Button>
                {/* <Button
                  icon
                  onClick={this.context.handleMIDIChange}
                  className="midi-button"
                  style={midiStyle}
                  disabled={!context.state.midiEnabled}
                >
                  {context.state.midi ? (
                    <img src={Logo2} height={20} width={15} className="midi-logo" alt="midi on" />
                  ) : (
                    <img
                      src={Logo3}
                      height={14.5}
                      width={13.25}
                      className="midi-logo"
                      alt="midi off"
                    />
                  )}
                </Button> */}
                <Button icon className="web-cam-button canvas-btn" onClick={this.askWebCamPermission}>
                  <Icon fitted name="camera" color="red" />
                </Button>
                <Button
                  icon
                  className="record-button canvas-btn"
                  onClick={this.toggleRecording}
                  style={{ backgroundColor: this.state.recording ? '#ffcccc' : undefined }}
                >
                  <Icon fitted name="circle" color={this.state.recording ? "red" : "grey"} />
                </Button>
                {this.state.hasRecording && (
                  <Button
                    icon
                    className="view-recording-button canvas-btn"
                    onClick={this.toggleRecordedSpectrogram}
                    style={{ backgroundColor: this.state.showRecordedSpectrogram ? '#ccffcc' : undefined }}
                  >
                    <Icon fitted name="eye" color={this.state.showRecordedSpectrogram ? "green" : "grey"} />
                    {this.state.recordingCount > 0 && (
                      <span className="recording-count-badge">{this.state.recordingCount}</span>
                    )}
                  </Button>
                )}
                {this.state.showRecordedSpectrogram && this.combinedSpectrogramCanvas && (
                  <div className="recording-scrollbar-container">
                    <button
                      className="scrollbar-play-pause-btn"
                      onClick={this.state.scrollbarPlaying ? this.pauseRecordingScroll : this.playRecordingScroll}
                    >
                      <Icon fitted name={this.state.scrollbarPlaying ? "pause" : "play"} color="blue" />
                    </button>
                    <input
                      type="range"
                      min="0"
                      max="1"
                      step="0.001"
                      value={this.state.recordingScrollPosition}
                      onChange={this.handleRecordingScroll}
                      className="recording-scrollbar"
                    />
                    {this.state.recordingCount > 0 && (
                      <>
                        <span className="recording-duration-label">
                          Duration: {this.getTotalRecordingsDuration().toFixed(2)}s
                        </span>
                        <Button
                          icon
                          size="mini"
                          className="clear-recordings-button"
                          onClick={this.clearAllRecordings}
                          title="Clear all recordings"
                        >
                          <Icon fitted name="trash" color="red" />
                        </Button>
                      </>
                    )}
                  </div>
                )}
                {/* Clip selection info bar */}
                {this.state.showRecordedSpectrogram && this.state.clipSelection && (
                  <div className="clip-selection-info">
                    <span className="clip-selection-label">
                      Selection: {this.getClipTimeRange() ?
                        `${this.getClipTimeRange().startTime.toFixed(2)}s - ${this.getClipTimeRange().endTime.toFixed(2)}s (${this.getClipTimeRange().duration.toFixed(2)}s)`
                        : ''}
                    </span>
                    <Button
                      icon
                      size="mini"
                      className="clip-action-btn"
                      onClick={this.toggleClipPlayback}
                      title={this.state.clipPlaying ? "Pause" : "Play selection"}
                    >
                      <Icon fitted name={this.state.clipPlaying ? "pause" : "play"} color="blue" />
                    </Button>
                    <input
                      type="text"
                      placeholder="Enter clip label..."
                      value={this.state.clipLabel}
                      onChange={this.handleClipLabelChange}
                      onFocus={() => this.setState({ showLabelSuggestions: true })}
                      onBlur={() => setTimeout(() => this.setState({ showLabelSuggestions: false }), 200)}
                      className="clip-label-input-inline"
                    />
                    {this.state.showLabelSuggestions && this.getLabelSuggestions().length > 0 && (
                      <div className="clip-label-suggestions">
                        {this.getLabelSuggestions().map((suggestion, idx) => (
                          <div
                            key={idx}
                            className="clip-label-suggestion-item"
                            onClick={() => this.setState({ clipLabel: suggestion })}
                          >
                            {suggestion}
                          </div>
                        ))}
                      </div>
                    )}
                    <Button
                      size="mini"
                      className="clip-action-btn"
                      onClick={this.saveClip}
                      title="Save selection"
                      color="Black"
                    >
                      <Icon fitted name="save" color="white" />
                    </Button>
                    <Button
                      icon
                      size="mini"
                      className="clip-clear-btn"
                      onClick={this.clearClipSelection}
                      title="Clear selection"
                    >
                      <Icon fitted name="close" color="red" />
                    </Button>
                  </div>
                )}
                {context.state.showPlaybackControls && (
                  <div className="playback-controls-container">
                    <Icon
                      fitted
                      name={context.state.audioFilePlayback ? 'stop' : 'play'}
                      color="black"
                      className="audio-file-play"
                      onClick={this.toggleAudio}
                    />
                    <Progress
                      size="tiny"
                      percent={context.state.audioFileProgress}
                      color="black"
                      className="audio-file-progress"
                    />
                    <Icon
                      fitted
                      name="delete"
                      color="black"
                      className="audio-file-delete"
                      onClick={this.stopAudio}
                    />
                  </div>
                )}
                <div className="color-map-container">
                  <div className="color-map-text">Graph Scale</div>
                  <div className="color-map"></div>
                  <div className="color-map-labels">
                    <div>Soft</div>
                    <div>Loud</div>
                  </div>
                </div>
                {/* Speed control moved into VolumeSettings pane (under menu) */}
                {/* <KeyHandler keyEventName={KEYUP} keyValue=" " onKeyHandle={this.spacePressed} /> */}
                {/* Renders sound or tuning mode based on variable above */}
                {context.state.tuningMode ? (
                  <Tuning
                    context={audioContext}
                    analyser={analyser}
                    ref={this.tuningRef}
                    handleResize={this.handleResize}
                    disableInteraction={this.state.showRecordedSpectrogram}
                  />
                ) : (
                  <SoundMaking
                    audioContext={audioContext}
                    analyser={analyser}
                    handleResize={this.handleResize}
                    ref={this.soundMakingRef}
                    disableInteraction={this.state.showRecordedSpectrogram}
                  />
                )}
                {/* Clip Selection Overlay - renders on top when viewing recorded spectrogram */}
                {this.state.showRecordedSpectrogram && (
                  <canvas
                    className="clip-selection-overlay"
                    width={context.state.width}
                    height={context.state.height}
                    onMouseDown={this.handleClipSelectionStart}
                    onMouseMove={this.handleClipSelectionMove}
                    onMouseUp={this.handleClipSelectionEnd}
                    onMouseLeave={this.handleClipSelectionEnd}
                    ref={(c) => { this.clipOverlayCanvas = c; }}
                  />
                )}
                <Axes
                  resolutionMax={context.state.resolutionMax}
                  resolutionMin={context.state.resolutionMin}
                  width={context.state.width}
                  height={context.state.height}
                  handleResize={this.handleResize}
                  log={context.state.log}
                  ref={this.axesRef}
                />
              </React.Fragment>
            )}
            {/* Intro Instructions */}
            {context.state.instr ? (
              <div>
                <div id="outside-instr" onClick={this.handleInstructionsClose}></div>
                <div id="instructions-bg" className={!this.state.instr ? '' : ''}>
                  <div id="close-instr" onClick={this.handleInstructionsClose}>
                    <Icon fitted link color="red" name="close" />
                  </div>
                  <div id="instructions">
                    {!context.state.isStarted ? (
                      <p className="flashing">Loading... Please wait...</p>
                    ) : (
                      <p>
                        Welcome to the Spectrogram! You can draw on the screen to make sound! To
                        allow microphone use, click or tap the microphone button on the top left
                        corner.
                      </p>
                    )
                      // ? <p className="flashing">Click or tap anywhere on the canvas to start the spectrogram</p>
                      // : <p>Great! Be sure to allow use of your microphone.
                      // You can draw on the canvas to make sound!</p>
                    }
                  </div>
                </div>
              </div>
            ) : (
              <div />
            )}

            {context.state.modal ? (
              <div className="modal">
                <div className="row">
                  <div className="column">
                    <div className="header">
                      <div className="title">
                        To Use the Live Spectrogram:
                        <br></br>
                        <br></br>
                        <Icon name="info circle" color="red" />
                        <div className="subtitle">You will need to allow microphone access!</div>
                        <Icon size="big" name="long arrow alternate right" color="black" />
                      </div>
                      <Button className="modalBtn" onClick={this.handleModalToggle}>
                        Close
                      </Button>
                    </div>
                  </div>
                  {/* <div class="step"> */}
                  <div className="column">
                    <p>
                      <b>1)</b> Look for the lock or info icon on the top left of the page, directly
                      to the left of your browser's address bar.
                    </p>
                    <img className="img" src={MicPerm1} alt=""></img>
                  </div>
                  {/* </div> */}
                  <div className="step">
                    <div className="row">
                      <p>
                        <b>2)</b> Click on the icon, then locate the "Microphone" field in the menu.
                      </p>
                      <img className="img" src={MicPerm2} alt=""></img>
                    </div>
                  </div>
                  {/* <div class="step"> */}
                  <div className="column">
                    <p>
                      <b>3)</b> Click on the field corresponding to Microphone, then select "Allow"
                      in the dropdown options.
                    </p>
                    <img className="img" src={MicPerm3} alt=""></img>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            ) : null}
            {/* {this.state.showAddToHomeScreen&& */}
            {/* <button onClick={this.addToHomeScreen}>Add to homescreen?</button> */}
            {/* } */}
            {this.state.webCamEnabled && (
              <WebCam
                ref={this.webCamRef}
                tsModel={context.state.tsModel}
                triggerMultiTouchEventsWithOnlyOpenedFingers={
                  this.triggerMultiTouchEventsWithOnlyOpenedFingers
                }
              />
            )}
          </div>
        )}
      </SpectrogramContext.Consumer>
    );
  }
}


Spectrogram.contextType = SpectrogramContext;

export default Spectrogram

// export default ReactAnimationFrame(Spectrogram);
